import update from 'immutability-helper';
import {isEmpty} from 'lodash';
import {useMemo} from 'react';

import {DashboardPanelData} from '../../../interfaces/Dashboard';
import {
  injectDashboardDates,
  useDashboardDates,
} from '../../../utils/dashboardDate';
import {
  AlarmHistoryTrackingReports,
  AlarmTrackingReportsData,
  getAlarmTrackingReportsData,
} from './AlarmHistoryTrackingReports';

interface Props {
  value?: DashboardPanelData;
  onUpdate?: (value?: DashboardPanelData) => void;
}
export interface AlarmNodeTrackingReportsData {
  viewType: 'alarms';
  title: string;
  alarm: AlarmTrackingReportsData;
}

const getAlarmNodeTrackingReports = (): AlarmNodeTrackingReportsData => ({
  viewType: 'alarms',
  title: 'Alarm Log Tracking Reports',
  alarm: getAlarmTrackingReportsData(),
});

export const AlarmHistoryReports = ({value, onUpdate}: Props) => {
  const config = useMemo(
    () =>
      !isEmpty(value)
        ? (value as AlarmNodeTrackingReportsData)
        : getAlarmNodeTrackingReports(),
    [value]
  );

  const dashboardDates = useDashboardDates(value?.detachedFromDashboardDate);

  const alarmValue = useMemo(() => {
    const base = config.alarm;
    if (!dashboardDates) {
      return base;
    }
    const newItems = injectDashboardDates(base.openedItems, dashboardDates);
    if (newItems === base.openedItems) {
      return base;
    }
    return {...base, openedItems: newItems};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.alarm, dashboardDates?.date_start, dashboardDates?.date_end]);

  return (
    <AlarmHistoryTrackingReports
      value={alarmValue}
      onUpdate={(v) => {
        let detach = false;
        if (
          dashboardDates &&
          v?.openedItems &&
          v.openedItems.length === config.alarm.openedItems.length
        ) {
          const activeIdx = v.openedItems.findIndex(
            (it) => it.id === (v.activeId ?? config.alarm.activeId)
          );
          const incoming =
            activeIdx >= 0 ? v.openedItems[activeIdx] : undefined;
          if (
            incoming &&
            (incoming.params?.date_start !== dashboardDates.date_start ||
              incoming.params?.date_end !== dashboardDates.date_end)
          ) {
            detach = true;
          }
        }
        const base = update(value ?? getAlarmNodeTrackingReports(), {
          alarm: {$set: v ?? getAlarmTrackingReportsData()},
        });
        onUpdate?.(detach ? {...base, detachedFromDashboardDate: true} : base);
      }}
    />
  );
};
